const getPhoneNumberRegex = () => {
  return /^\+(1|92) \((\d{3})\) (\d{3}-\d{4})$/;
};

const getPhoneNumberPlainRegex = () => {
  return /^\+(1|92)\d{10}$/;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  // Format the number according to the pattern
  return cleaned.replace(/^(\+\d{1,3})(\d{3})(\d{3})(\d{4})$/, '+$1 ($2) $3-$4');
};

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //NOSONAR

export { emailRegex, getPhoneNumberRegex, getPhoneNumberPlainRegex };
